import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../_metronic/_helpers";

// Drop-in replacement for <input type="password" .../> - accepts every
// prop a normal input does (className/placeholder/name/value/onChange or
// {...formik.getFieldProps(x)}, etc.) and adds a show/hide toggle button.
export default function PasswordInput({ className = "", ...rest }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-input-wrapper" style={{ position: "relative" }}>
      <input
        {...rest}
        type={visible ? "text" : "password"}
        className={className}
        style={{ paddingRight: "3rem", ...(rest.style || {}) }}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          top: "50%",
          right: "0.75rem",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          opacity: 0.6
        }}
      >
        <span className="svg-icon svg-icon-md">
          <SVG
            src={toAbsoluteUrl(
              visible
                ? "/media/svg/icons/General/Hidden.svg"
                : "/media/svg/icons/General/Visible.svg"
            )}
          />
        </span>
      </button>
    </div>
  );
}
